<template>
  <div class="mainView">
    <div class="topView">
      <div class="buttonView">
        <el-radio-group v-model="tabPosition"
                        size="mini"
                        @input="monthYearChange">
          <el-radio-button label="month">月统计</el-radio-button>
          <el-radio-button label="year">年统计</el-radio-button>
        </el-radio-group>
      </div>
      <div class="buttonView">
        <el-button type="text" style="margin-right: 20px;color: #595959;font-weight: 600;" v-if="monthOrYear == 'month'">{{years[0]}}</el-button>
        <div v-else >
          <el-button size="small" :type=" year == item ? 'primary':'text' " style="margin-right: 20px;font-weight: 600;" :style="{color: year == item ? '#fff' : '#595959'}" v-for="item,index in years" :key="index" @click="changeYear(item)">{{item}}</el-button>
        </div>
        <div style="height: 56px;">
          <el-tabs v-model="monthSelectIndex"
                   @tab-click="handleClick"
                   v-show="monthOrYear == 'month'">
            <el-tab-pane :label="item.str"
                         :name="index+''"
                         v-for="item,index in monthArr"
                         :key="index"></el-tab-pane>
          </el-tabs>
        </div>
      </div>
    </div>
    <div class="goodsSalesStatMain"
         ref="goodsSalesStatMain">
      <div class="flexLineView mainHeight">
        <div class="leftHalf">
          <highcharts :options="lineOptions" />
        </div>

        <el-table :data="tableData"
                  style="width: 100%;"
                  :height="tableHeight"
                  highlight-current-row
                  @current-change="handleCurrentChange"
                  ref="firstTable">
          <el-table-column prop="rn"
                           label="排名"
                           width="50">
          </el-table-column>
          <el-table-column prop="goods_name"
                           label="药品名称">
          </el-table-column>
          <el-table-column prop="shop_name"
                           label="供应商">
          </el-table-column>
          <el-table-column prop="qty"
                           label="销售数量"
                           width="100">
          </el-table-column>
          <el-table-column prop="amount"
                           label="销售金额(元)">
          </el-table-column>
          <el-table-column label="销售占比"
                           width="100">
            <template slot-scope="scope">
              <div class="percentView">
                <div class="percentBg"
                     :style="{width:getPercent(scope.row.pct)+'%'}"></div>
                <div class="percentText">{{getPercent(scope.row.pct)}}%</div>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <div class="dropDownBtn">
          <el-dropdown @command="dropdownClick">
            <el-button type="default"
                       size="mini">
              {{controls[controlSelectType]}}<i class="el-icon-arrow-down el-icon--right"></i>
            </el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="2">控销药</el-dropdown-item>
              <el-dropdown-item command="1">普药</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>

        </div>
        <div class="numberView">
          <img :src="number1"
               alt=""
               class="numberImg">
        </div>
      </div>
      <div class="lineView"></div>
      <div class="flexLineView">
        <div class="row">
          <highcharts :options="chartOptions"
                      v-if="chartOptions" />
          <div class="numberView">
            <img :src="number2"
                 alt=""
                 class="numberImg">
          </div>
        </div>
        <div class="lineViewHorizon"></div>
        <div class="secondTableView"
            >
          <div class="classNameView">
            <span style="font-weight: 600;color: #262626;font-size: 16px;margin-right: 10px;">所在类目名次</span>
            <span v-if="firstSelectData && firstSelectData.goods_one_class_name">{{firstSelectData?firstSelectData.goods_one_class_name+'/'+firstSelectData.goods_two_class_name+'/'+firstSelectData.goods_three_class_name : ''}}</span>
          </div>
          <el-table :data="categoryTableData"
                    style="width: 100%;"
                    highlight-current-row
                    :height="tableHeight - 50"
                    ref="hilightTable">
            <el-table-column prop="rn"
                             label="排名"
                             width="50">
            </el-table-column>
            <el-table-column prop="goods_name"
                             label="药品名称">
            </el-table-column>
            <el-table-column prop="shop_name"
                             label="供应商名称">
            </el-table-column>
            <el-table-column prop="qty"
                             label="销售数量"
                             width="100">
            </el-table-column>
            <el-table-column prop="amount"
                             label="销售金额(元)">
            </el-table-column>
            <el-table-column label="销售占比"
                             width="100">
              <template slot-scope="scope">
                <div class="percentView">
                  <div class="percentBg"
                       :style="{width:getPercent(scope.row.pct)+'%'}"></div>
                  <div class="percentText">{{getPercent(scope.row.pct)}}%</div>
                </div>
              </template>
            </el-table-column>
          </el-table>
          <div class="numberView">
            <img :src="number2"
                 alt=""
                 class="numberImg">
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { queryGoodsSalesEcharts } from "@/api/statistics";
import number1 from "@/assets/number1.png";
import number2 from "@/assets/number2.png";
import dayjs from 'dayjs'
export default {
  data () {
    return {
      tabPosition: 'month',
      eachRowWidth: 0,
      top10: [],
      tableData: [],
      categoryTableData: [],
      tableHeight: 0,
      chartOptions: undefined,
      lineOptions: {},
      controls: ['', '普药', '控销药'],
      controlSelectType: 2,
      monthArr: [],
      monthSelectIndex: 0,
      year: dayjs().format('YYYY'),
      years:[],
      monthOrYear: 'month',
      firstSelectData: undefined,
      number2: number2,
      number1: number1
    }
  },

  async mounted () {
    const mainWindow = this.$refs.goodsSalesStatMain
    this.eachRowWidth = (mainWindow.offsetWidth - 12) / 2
    this.tableHeight = (mainWindow.offsetHeight - 12 - 24) / 2
    mainWindow.style.setProperty('--row-width', this.eachRowWidth + 'px')
    mainWindow.style.setProperty('--main-height', mainWindow.offsetHeight - 24 + 'px')
    await this.getMonthArr()
    await this.getData(1)

  },
  methods: {
    async getData (type, data) {
      // 2023 8
      // type	类型（与报表端确认，一个接口一个类型） 月 1,2,3  /  年 4,5,6
      // params	参数组(示例： '202308','2' )  '202308','2','1696371675141570561'   /  时间  ， 2 控销  1普药 ，
      const m = this.monthArr[this.monthSelectIndex].m
      const postDate = this.monthOrYear == 'year' ? this.year : this.year + m
      type = this.monthOrYear == 'year' ? type + 3 : type
      let obj = {
        type: type,
      }
      if (type == 1 || type == 4) {
        obj['params'] = [postDate, this.controlSelectType]
      } else if (type == 2 || type == 5) {
        obj['params'] = [postDate, this.controlSelectType, data.goods_id, data.goods_name, data.shop_id, postDate] //goodsid  goodsname   shopid
      } else if (type == 3 || type == 6) {
        obj['params'] = [postDate, this.controlSelectType, data.goods_three_class_id] //threeclassid
      }
      // let obj = {
      //     type: 2,
      //     params:['202308','2','1674250188351930369','消肿止痛贴(1贴*20贴/盒)','1661257547503419393','202308'] //goodsid  goodsname   shopid
      // }
      // let obj = {
      //     type: 3,
      //     params:['202308','2','1696371675141570561' ] //threeclassid
      // }
      const resp = await queryGoodsSalesEcharts(obj)
      if (resp && resp.length) {
        if (type == 1 || type == 4) {
          // 按月1  按年4 
          if (resp.length > 10) {
            this.tableData = resp.slice(10, resp.length)
            this.top10 = resp.slice(0, 10)
          } else {
            this.tableData = []
            this.top10 = resp
          }
          const data = this.top10[0]
          this.firstSelectData = data
          this.getData(2, data)
          this.getData(3, data)
          this.setTableFirst(0)


        } else if (type == 2 || type == 5) {
          // 按月2  按年5
          this.setTableSecond(resp || [], data)
        } else if (type == 3 || type == 6) {
          // 按月3  按年6
          const firstData = this.firstSelectData
          let didSelect = {}
          resp.forEach(e => {
            if (e.goods_id == firstData.goods_id && e.goods_name == firstData.goods_name && e.shop_id == firstData.shop_id) {
              e['select'] = true
              didSelect = e
            }
          });
          this.categoryTableData = resp
          setTimeout(() => {
            this.$nextTick(() => {
              this.$refs.hilightTable && this.$refs.hilightTable.setCurrentRow(didSelect);
            })
          }, 500);
        }

      } else {
        if (type == 1 || type == 4) {
          this.resetDefault()
        } else if (type == 2 || type == 5) {
          this.chartOptions = undefined
        } else if (type == 3 || type == 6) {
          this.categoryTableData = []
        }
      }
    },
    getRowKeys (row) {
      return row.goods_id + row.goods_name + row.shop_id
    },
    monthYearChange (e) {
      // 切换年 或者 月
      this.monthOrYear = e
      this.year = this.years[0]
      this.getData(1)
    },
    getMonthArr () {
      // 初始化月份数组
      let m = Number(dayjs().format('MM'))
      let monthArr = []
      for (let index = 1; index <= m; index++) {
        monthArr.unshift({ m: index < 10 ? '0' + index : index, str: index + '月' })
      }
      this.monthSelectIndex = 0
      this.monthArr = monthArr
      // 初始化年份数组  从2023开始 -  当前年份
      let startYear = dayjs('2023').format('YYYY')
      let endYear = dayjs().format('YYYY')
      if (startYear == endYear) {
         this.years = [startYear]
      } else {
        for (let index = startYear; index <= endYear; index++) {
          this.years.unshift(index + '')
        }
      }
      this.year = this.years[0]
    },
    getPercent (v) {
      if (!v) {
        return '0.00'
      }
      return (v * 100).toFixed(2)
    },
    dropdownClick (e) {
      // 下拉选择控销或者普药
      this.controlSelectType = e
      this.getData(1)
    },
    resetDefault () {
      // 重置默认数据
      this.chartOptions = undefined
      this.top10 = []
      this.tableData = []
      this.categoryTableData = []
      this.setTableFirst()
    },
    handleClassName (e) {
      if (e.row.select) {

        return 'qwer'
      }
    },
    changeYear(year){
      // 切换年份
      this.year = year
      this.getData(1)
    },
    handleClick (e) {
      // 点击月份
      this.monthSelectIndex = e.index
      this.getData(1)
    },
    handleCurrentChange (e) {
      // 点击第一个table的某一项
      this.firstSelectData = e
      this.getData(2, e)
      this.getData(3, e)
      this.setTableFirst(99999)
    },
    setTableFirst (selectIndex = 0) {
      // 设置销量排名图表
      let tmp = []
      let arr = this.top10
      arr.forEach((e, index) => {
        if (index == selectIndex) {
          // {linearGradient: { x1: 0, y1: 0, x2: 0, y2: 1 },stops: [[0, "#FBBC5E"],[1, "#F99B0D"]]}
          tmp.push({ ...e, name: 'TOP' + (index + 1), y: parseInt(e.qty), color: '#73DEB3' })
        } else {
          tmp.push({ ...e, name: 'TOP' + (index + 1), y: parseInt(e.qty), color: '#73A0FA' })

        }

      });
      let _this = this
      const timeStr = dayjs().subtract(1, 'day').format('YYYY-MM-DD')
      this.lineOptions = {

        credits: {
          enabled: false
        },
        exporting: { enabled: false },
        chart: {
          type: 'column',
          height: this.tableHeight
        },

        title: {
          align: 'left',
          text: `<span style="color:#262626;font-size:16px;font-weight:600;">销量排名<span style="color:#595959;font-size:12px;font-weight:400;padding-left:10px;">&nbsp;&nbsp;数据更新时间${timeStr}</span></span>`
        },
        // subtitle: {
        //     align: 'left',
        //     text: '数据更新时间'+ dayjs().subtract(1,'day').format('YYYY-MM-DD')
        // },
        accessibility: {
          announceNewData: {
            enabled: true
          }
        },
        xAxis: {
          type: 'category'
        },
        yAxis: {
          title: {
            text: ''
          }

        },
        legend: {
          enabled: false
        },
        plotOptions: {
          series: {
            // allowPointSelect: true,// 是否允许选中点
            events: {
              click: function (e) {
                const index = e.point.index
                _this.$refs.firstTable && _this.$refs.firstTable.setCurrentRow();
                _this.firstSelectData = e.point.options
                _this.setTableFirst(index)
                _this.getData(2, e.point.options)
                _this.getData(3, e.point.options)

              },
            },
            borderWidth: 0,
            dataLabels: {
              enabled: true,
              format: '{point.y}'
              // format: '{point.y:.2f}'
            }
          }
        },
        tooltip: {
          headerFormat: '<span style="font-size:11px">{point.goods_name}</span><br>',
          pointFormat: '<span style="font-size:14px">{point.shop_name}</span><br><span style="color:{point.color}">{point.goods_name}</span>: <b>{point.amount:.2f}</b><br/>'
        },
        series: [
          {
            name: '',
            colorByPoint: false,
            data: tmp
          }
        ],
      }
    },
    setTableSecond (arr, data) {
      // 设置销售趋势图表
      let tmp = []
      let days = []
      arr.forEach(e => {
        tmp.push(parseFloat(e.amount))
        days.push(e.id)
      });
      this.chartOptions = {
        colors: ['#F5222D'],
        credits: {
          enabled: false
        },
        chart: {
          height: this.tableHeight - 24
        },
        exporting: { enabled: false },
        title: {
          text: `<span style="color:#262626;font-size:16px;font-weight:600;">销售趋势<span style="color:#595959;font-size:12px;font-weight:400;">&nbsp;&nbsp;${data.shop_name}</span></span>`,
          align: 'left'
        },
        // subtitle: {
        //     text: data.shop_name,
        //     align: 'left'
        // },
        yAxis: {
          title: {
            enabled: false
            // text: '就业人数'
          }
        },
        legend: {
          enabled: false
        },
        plotOptions: {
          spline: {
            marker: {
              radius: 4,
              lineColor: '#666666',
              lineWidth: 1
            }
          },
          series:{
            dataLabels: {
              enabled: true,
              // format: '{point.y}'
              format: '{point.y:.2f}'
            }
          }
        },
        xAxis: {
          categories: days,
        },
        tooltip: {
          pointFormat: '<span> 销售额：{point.y:.2f}</span>'
        },
        series: [{
          name: '销售额',
          data: tmp
        }],
      }
    }

  },

}

</script>
<style lang="scss" scoped>
$eachWidth: var(--row-width, "500px");
$mainHeight: var(--main-height, "600px");

.mainView {
  height: 100%;
  width: 100%;
  .topView {
    background-color: #fff;
    padding: 12px;
    border-radius: 4px;
    overflow: hidden;
    .buttonView {
      display: flex;
      align-items: center;
    }
  }

  .goodsSalesStatMain {
    display: flex;
    flex: 1;
    flex-direction: row;
    height: calc(100% - 84px - 12px);
    margin-top: 12px;

    .flexLineView {
      display: flex;
      flex-direction: column;
      flex: 1;
      width: $eachWidth;

      .row {
        width: $eachWidth;

        background-color: #fff;
        border-radius: 4px;
        overflow: hidden;
        height: calc(($mainHeight / 2));
        padding: 12px;
        position: relative;
      }
    }

    .mainHeight {
      height: $mainHeight;
      border-radius: 4px;
      overflow: hidden;

      background-color: #fff;
      position: relative;
      padding: 12px;
    }
    .dropDownBtn {
      position: absolute;
      top: 12px;
      right: 12px;
    }
    .numberView {
      position: absolute;
      top: 0px;
      left: 0px;
      .numberImg {
        width: 20px;
        height: 20px;
      }
    }
    .leftHalf {
      height: calc((($mainHeight) / 2));
    }
    .lineViewHorizon {
      height: 12px;
    }
    .secondTableView {
      position: relative;
      padding: 12px;
      background-color: #fff;
      border-radius: 4px;
      overflow: hidden;
      .classNameView {
        display: flex;
        align-items: center;
        height: 30px;
        font-size: 14px;
        color: #595959;
        background-color: #fff;
        padding-left: 12px;
      }
    }
    .lineView {
      width: 12px;
    }
  }
  .percentView {
    position: relative;
    z-index: 999;
    background-color: #f0f0f0;
    .percentBg {
      position: absolute;
      left: 0;
      top: 0;
      height: 100%;
      z-index: -1;
      background-color: #fbabaf;
    }
    .percentText {
      height: 100%;
      width: 100%;
      z-index: 999;
      text-align: right;
    }
  }
}
</style>